import { render, staticRenderFns } from "./BuyerCampaignsList.vue?vue&type=template&id=7bc250dd&scoped=true"
import script from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
import style0 from "./BuyerCampaignsList.vue?vue&type=style&index=0&id=7bc250dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc250dd",
  null
  
)

export default component.exports